var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('plain-link-button');
import { breakpoints, theme } from '@shapeable/theme';
export var PlainLinkButtonDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   ", ";\n    font-family: ", ";\n    cursor: pointer;\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n   ", ";\n    font-family: ", ";\n    cursor: pointer;\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.FONT('sans'), theme.COLOR('link'), theme.COLOR('link-hover'))
});
// -------- Components -------->
var My = {
  Container: styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var PlainLinkButton = function (props) {
  var className = props.className,
    children = props.children,
    onClick = props.onClick;
  return React.createElement(My.Container, {
    onClick: onClick,
    className: cls.name(className)
  }, children);
};
PlainLinkButton.defaultProps = PlainLinkButtonDefaultProps;
PlainLinkButton.cls = cls;
var templateObject_1, templateObject_2;